export enum NotificationsType {
  Archive,
  Unread,
}
